import { DataTable } from '../DataTable/DataTable'
import { buildInventorySystemProfileToVenuesTableColumns } from './helpers/buildInventorySystemProfileToVenuesTableColumns'
import type { InventorySystemProfileToVenuesTableProps } from './InventorySystemProfileToVenuesTable.types'

export function InventorySystemProfileToVenuesTable({
  mappings,
  profiles,
  venues,
  tenantGroups,
  onRowClick,
}: InventorySystemProfileToVenuesTableProps) {
  return (
    <DataTable
      columns={buildInventorySystemProfileToVenuesTableColumns(
        profiles,
        venues,
        tenantGroups
      )}
      data={mappings}
      rowKey={(m) => `${m.inventorySystemProfileId}:${m.venueId}`}
      emptyMessage="No ISP to venue mappings found."
      onRowClick={onRowClick}
      defaultSortHeader="Venue"
    />
  )
}
